// @flow
import * as React from 'react';
import styled, { type StyledComponent } from 'styled-components';
import noop from 'lodash/fp/noop';

import { makeId } from 'modules/model';
import useTranslations from 'custom-hooks/use-translations';
import Modal from 'ui/design-system/modal';
import Text from 'ui/design-system/text';

export type Props = $ReadOnly<{|
  isOpen: boolean,
  downloadOrderJSON?: () => void,
|}>;

export const ModalInnerWrapper: StyledComponent<
  {},
  {},
  HTMLDivElement,
> = styled.div``;

export const SupportLink: StyledComponent<
  {},
  {},
  HTMLAnchorElement,
> = styled.a``;

const OfflineNotificationModal = ({
  isOpen,
  downloadOrderJSON,
}: Props): React.Node => {
  const { translate, translateWithTagReplacements } = useTranslations();

  const handleDownloadOrderJSON = React.useCallback(() => {
    if (downloadOrderJSON) downloadOrderJSON();
  }, [downloadOrderJSON]);

  return (
    <Modal
      isOpen={isOpen}
      appElement={window.root}
      title={translate('internet_connection_lost')}
      onRequestClose={noop}
      usesCornerCloseButton={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      actions={
        downloadOrderJSON
          ? [
              {
                type: 'primary',
                label: translate('download_backup_data_file'),
                handleClick: handleDownloadOrderJSON,
              },
            ]
          : undefined
      }
    >
      <ModalInnerWrapper>
        {downloadOrderJSON ? (
          translateWithTagReplacements(
            'internet_connection_lost_builder_description',
            { ...null },
            {
              Link: (children) => (
                <SupportLink
                  key={String(makeId())}
                  href="mailto: support@elasticsuite.com"
                >
                  {children}
                </SupportLink>
              ),
              p: (children) => (
                <Text key={String(makeId())} is="p" marginBottom="16px">
                  {children}
                </Text>
              ),
            },
          )
        ) : (
          <Text is="p" marginBottom="16px">
            {translate('internet_connection_lost_description')}
          </Text>
        )}
      </ModalInnerWrapper>
    </Modal>
  );
};

export default OfflineNotificationModal;
